webpackJsonp([34],{

/***/ 1108:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="36" height="45" viewBox="0 0 36 45" xmlns="http://www.w3.org/2000/svg"><path d="M17 9.5l-17 17 17.607 17.607 17.5-17.5L26 17.5V0l-9 9.5z"/></svg>'};

/***/ }),

/***/ 1341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _find = __webpack_require__(228);

var _find2 = _interopRequireDefault(_find);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _utilities = __webpack_require__(51);

var _icon_single_quote_blue = __webpack_require__(1108);

var _icon_single_quote_blue2 = _interopRequireDefault(_icon_single_quote_blue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'amp-blockquote',
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  components: {
    AmpSharePane: function AmpSharePane() {
      return __webpack_require__.e/* import() */(20/* duplicate */).then(__webpack_require__.bind(null, 1317));
    },
    SingleQuoteSvg: _icon_single_quote_blue2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['activeNID']), {
    node: function node() {
      return this.$store.getters.node(this.activeNID);
    },
    itemQuotes: function itemQuotes() {
      return (0, _get2.default)(this, 'item.content.quotes', []);
    },
    relatedElement: function relatedElement() {
      var relatedElementRef = (0, _get2.default)(this, 'item.content.relatedElementRef', '');
      return (0, _get2.default)(this, '$parent.$refs[' + relatedElementRef + '][0]', {});
    },
    style: function style() {
      var style = {
        top: this.styleTop === 'auto' ? 'auto' : (0, _utilities.numberToRem)((0, _get2.default)(this, 'styleTop', 0))
      };
      return style;
    },
    shareUrl: function shareUrl() {
      return this.node ? '' + this.requestDomain() + (0, _get2.default)(this.node, 'relative_url', '') : '';
    },
    shareTitle: function shareTitle() {
      var quote = (0, _get2.default)((0, _find2.default)(this.itemQuotes, { quoteType: 'default' }), 'value', false);
      var author = (0, _get2.default)((0, _find2.default)(this.itemQuotes, { quoteType: 'author' }), 'value', false);

      if (quote && author) return '"' + quote + '", ' + author;

      return '';
    },
    shareThumbnail: function shareThumbnail() {
      return (0, _get2.default)(this, 'node.images[0].style_700x400', '');
    }
  }),
  methods: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['requestDomain']), {
    repositionQuoteToRelatedEl: function repositionQuoteToRelatedEl() {
      if (!(0, _isEmpty2.default)(this.relatedElement) && this.isBodyLeftQuoteMode) {
        this.styleTop = (0, _get2.default)(this, 'relatedElement.$el.offsetTop', 'auto');
      }
      return false;
    },
    quoteClassName: function quoteClassName(quoteType) {
      switch (quoteType) {
        case 'default':
          return 'blockquote-quote';
        case 'author':
          return 'blockquote-author';
        default:
          {
            return 'blockquote-quote';
          }
      }
    }
  })
};

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".fade-enter-active[data-v-3065d5f2]{-webkit-transition:opacity .5s ease-in-out;-o-transition:opacity .5s ease-in-out;transition:opacity .5s ease-in-out}.fade-leave-active[data-v-3065d5f2]{-webkit-transition:opacity .2s ease;-o-transition:opacity .2s ease;transition:opacity .2s ease}.fade-enter[data-v-3065d5f2],.fade-leave-to[data-v-3065d5f2]{opacity:0}@-webkit-keyframes rotating{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes rotating-data-v-3065d5f2{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@-webkit-keyframes quoteFlickering{50%{fill:#18ffff}}@keyframes quoteFlickering-data-v-3065d5f2{50%{fill:#18ffff}}@-webkit-keyframes quoteFlickeringReverse{50%{fill:#76ffff}}@keyframes quoteFlickeringReverse-data-v-3065d5f2{50%{fill:#76ffff}}.quote[data-v-3065d5f2]{position:relative;background-color:#fff}.quote-container[data-v-3065d5f2]{font-family:Barlow,sans-serif;margin-left:1.6875rem;margin-right:1.6875rem;padding-bottom:.9375rem;-o-border-image:-o-linear-gradient(left,#f8008e,#00e8ff);border-image:-webkit-gradient(linear,left top,right top,from(#f8008e),to(#00e8ff));border-image:linear-gradient(90deg,#f8008e,#00e8ff);border-image-slice:1;border-style:solid;border-width:0 0 .1875rem}.blockquote-quote[data-v-3065d5f2]{font-size:1.625rem;line-height:2.0625rem;font-style:italic;-o-border-image:-o-linear-gradient(left,#f8008e,#00e8ff);border-image:-webkit-gradient(linear,left top,right top,from(#f8008e),to(#00e8ff));border-image:linear-gradient(90deg,#f8008e,#00e8ff);border-image-slice:1;border-style:solid;border-width:.1875rem 0 0;margin-top:2.8125rem;padding-top:1.25rem;padding-left:.625rem;padding-right:.625rem;color:#f8008e;font-family:Barlow,sans-serif;font-weight:700}.blockquote-quote .quotes[data-v-3065d5f2]{position:absolute;top:-2.0625rem;left:.625rem;width:5rem;height:2.75rem}.blockquote-quote .quotes__icon[data-v-3065d5f2]{display:inline-block;position:relative;width:2.1875rem;margin-right:.1875rem}.blockquote-quote .quotes__icon:first-child svg[data-v-3065d5f2]{fill:#76ffff;-webkit-animation:quoteFlickering-data-v-3065d5f2 1s step-start infinite alternate;animation:quoteFlickering-data-v-3065d5f2 1s step-start infinite alternate}.blockquote-quote .quotes__icon:last-child svg[data-v-3065d5f2]{fill:#18ffff;-webkit-animation:quoteFlickeringReverse-data-v-3065d5f2 1s step-start infinite alternate;animation:quoteFlickeringReverse-data-v-3065d5f2 1s step-start infinite alternate}.blockquote-author[data-v-3065d5f2]{color:#00cbcc;padding:0 .625rem;text-transform:uppercase;z-index:2}@media (min-width:1024px){.blockquote-author[data-v-3065d5f2]{font-size:.875rem;line-height:1.3125rem;font-weight:400}}@media (min-width:0) and (max-width:1023px){.blockquote-author[data-v-3065d5f2]{font-size:.875rem;line-height:1rem;padding-top:.75rem}}.blockquote-author .quotes[data-v-3065d5f2]{display:none}", "", {"version":3,"sources":["/app/components/article/amp/AmpBlockquote.vue"],"names":[],"mappings":"AAgCA,oCACE,2CAA6C,AAC7C,sCAAwC,AACxC,kCAAqC,CACtC,AACD,oCACE,oCAAsC,AACtC,+BAAiC,AACjC,2BAA8B,CAC/B,AACD,6DAEE,SAAW,CACZ,AACD,4BACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,iCAAkC,AAClC,wBAA0B,CAC7B,CACA,AACD,oCACA,GACI,+BAAgC,AAChC,sBAAwB,CAC3B,AACD,GACI,iCAAkC,AAClC,wBAA0B,CAC7B,CACA,AACD,mCACA,IACI,YAAc,CACjB,CACA,AACD,2CACA,IACI,YAAc,CACjB,CACA,AACD,0CACA,IACI,YAAc,CACjB,CACA,AACD,kDACA,IACI,YAAc,CACjB,CACA,AACD,wBACE,kBAAmB,AACnB,qBAA0B,CAC3B,AACD,kCACE,8BAAkC,AAClC,sBAAuB,AACvB,uBAAwB,AACxB,wBAA0B,AAC1B,yDAA4D,AACzD,mFAAwF,AACxF,oDAA0D,AAC7D,qBAAsB,AACtB,mBAAoB,AACpB,yBAA8B,CAC/B,AACD,mCACE,mBAAoB,AACpB,sBAAuB,AACvB,kBAAmB,AACnB,yDAA4D,AACzD,mFAAwF,AACxF,oDAA0D,AAC7D,qBAAsB,AACtB,mBAAoB,AACpB,0BAA8B,AAC9B,qBAAsB,AACtB,oBAAqB,AACrB,qBAAuB,AACvB,sBAAwB,AACxB,cAAe,AACf,8BAAkC,AAClC,eAAkB,CACnB,AACD,2CACI,kBAAmB,AACnB,eAAgB,AAChB,aAAe,AACf,WAAY,AACZ,cAAgB,CACnB,AACD,iDACM,qBAAsB,AACtB,kBAAmB,AACnB,gBAAiB,AACjB,qBAAwB,CAC7B,AACD,iEACQ,aAAc,AACd,mFAAoF,AAC5E,0EAA4E,CAC3F,AACD,gEACQ,aAAc,AACd,0FAA2F,AACnF,iFAAmF,CAClG,AACD,oCAGE,cAAe,AACf,kBAA+B,AAC/B,yBAA0B,AAC1B,SAAW,CACZ,AACD,0BACA,oCACM,kBAAoB,AACpB,sBAAuB,AACvB,eAAqB,CAC1B,CACA,AACD,4CACA,oCACM,kBAAoB,AACpB,iBAAkB,AAClB,kBAAqB,CAC1B,CACA,AACD,4CACI,YAAc,CACjB","file":"AmpBlockquote.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.fade-enter-active[data-v-3065d5f2] {\n  -webkit-transition: opacity 0.5s ease-in-out;\n  -o-transition: opacity 0.5s ease-in-out;\n  transition: opacity 0.5s ease-in-out;\n}\n.fade-leave-active[data-v-3065d5f2] {\n  -webkit-transition: opacity 0.2s ease;\n  -o-transition: opacity 0.2s ease;\n  transition: opacity 0.2s ease;\n}\n.fade-enter[data-v-3065d5f2],\n.fade-leave-to[data-v-3065d5f2] {\n  opacity: 0;\n}\n@-webkit-keyframes rotating {\nfrom {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\nto {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n}\n}\n@keyframes rotating-data-v-3065d5f2 {\nfrom {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n}\nto {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n}\n}\n@-webkit-keyframes quoteFlickering {\n50% {\n    fill: #18FFFF;\n}\n}\n@keyframes quoteFlickering-data-v-3065d5f2 {\n50% {\n    fill: #18FFFF;\n}\n}\n@-webkit-keyframes quoteFlickeringReverse {\n50% {\n    fill: #76FFFF;\n}\n}\n@keyframes quoteFlickeringReverse-data-v-3065d5f2 {\n50% {\n    fill: #76FFFF;\n}\n}\n.quote[data-v-3065d5f2] {\n  position: relative;\n  background-color: #FFFFFF;\n}\n.quote-container[data-v-3065d5f2] {\n  font-family: \"Barlow\", sans-serif;\n  margin-left: 1.6875rem;\n  margin-right: 1.6875rem;\n  padding-bottom: 0.9375rem;\n  -o-border-image: -o-linear-gradient(left, #F8008E, #00E8FF);\n     border-image: -webkit-gradient(linear, left top, right top, from(#F8008E), to(#00E8FF));\n     border-image: linear-gradient(to right, #F8008E, #00E8FF);\n  border-image-slice: 1;\n  border-style: solid;\n  border-width: 0 0 0.1875rem 0;\n}\n.blockquote-quote[data-v-3065d5f2] {\n  font-size: 1.625rem;\n  line-height: 2.0625rem;\n  font-style: italic;\n  -o-border-image: -o-linear-gradient(left, #F8008E, #00E8FF);\n     border-image: -webkit-gradient(linear, left top, right top, from(#F8008E), to(#00E8FF));\n     border-image: linear-gradient(to right, #F8008E, #00E8FF);\n  border-image-slice: 1;\n  border-style: solid;\n  border-width: 0.1875rem 0 0 0;\n  margin-top: 2.8125rem;\n  padding-top: 1.25rem;\n  padding-left: 0.625rem;\n  padding-right: 0.625rem;\n  color: #F8008E;\n  font-family: \"Barlow\", sans-serif;\n  font-weight: bold;\n}\n.blockquote-quote .quotes[data-v-3065d5f2] {\n    position: absolute;\n    top: -2.0625rem;\n    left: 0.625rem;\n    width: 5rem;\n    height: 2.75rem;\n}\n.blockquote-quote .quotes__icon[data-v-3065d5f2] {\n      display: inline-block;\n      position: relative;\n      width: 2.1875rem;\n      margin-right: 0.1875rem;\n}\n.blockquote-quote .quotes__icon:first-child svg[data-v-3065d5f2] {\n        fill: #76FFFF;\n        -webkit-animation: quoteFlickering-data-v-3065d5f2 1s step-start infinite alternate;\n                animation: quoteFlickering-data-v-3065d5f2 1s step-start infinite alternate;\n}\n.blockquote-quote .quotes__icon:last-child svg[data-v-3065d5f2] {\n        fill: #18FFFF;\n        -webkit-animation: quoteFlickeringReverse-data-v-3065d5f2 1s step-start infinite alternate;\n                animation: quoteFlickeringReverse-data-v-3065d5f2 1s step-start infinite alternate;\n}\n.blockquote-author[data-v-3065d5f2] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n  color: #00CBCC;\n  padding: 0 0.625rem 0 0.625rem;\n  text-transform: uppercase;\n  z-index: 2;\n}\n@media (min-width: 1024px) {\n.blockquote-author[data-v-3065d5f2] {\n      font-size: 0.875rem;\n      line-height: 1.3125rem;\n      font-weight: initial;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.blockquote-author[data-v-3065d5f2] {\n      font-size: 0.875rem;\n      line-height: 1rem;\n      padding-top: 0.75rem;\n}\n}\n.blockquote-author .quotes[data-v-3065d5f2] {\n    display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1476);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("c36af35e", content, true, {});

/***/ }),

/***/ 1685:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1565)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1341),
  /* template */
  __webpack_require__(1734),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3065d5f2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1734:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-body-blockquote",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "quote-container"
  }, [_vm._l((_vm.itemQuotes), function(quote, index) {
    return [_c('div', {
      key: index,
      class: [_vm.quoteClassName(quote.quoteType), 'quote']
    }, [_c('div', {
      staticClass: "quotes"
    }, [_c('div', {
      staticClass: "quotes__icon"
    }, [_c('single-quote-svg')], 1), _c('div', {
      staticClass: "quotes__icon"
    }, [_c('single-quote-svg')], 1)]), _vm._v("\n        " + _vm._s(quote.value) + "\n      ")])]
  })], 2), _c('div', {
    staticClass: "share-buttons-container"
  }, [_c('amp-share-pane', {
    attrs: {
      "node": _vm.node,
      "mode": 'blockquote',
      "quote": _vm.shareTitle
    }
  })], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 34.43f82f29a658f8303624.js